/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import type { SafeCircleMode } from "@/types/safecircle";

const LEGACY_MODE_MAP = {
  kids: "protected",
  teens: "connected",
  women: "private",
} as const satisfies Record<string, SafeCircleMode>;

export function migrateLegacyModeValue(mode: string | undefined): SafeCircleMode | undefined {
  if (!mode) return undefined;
  if (mode in LEGACY_MODE_MAP) {
    return LEGACY_MODE_MAP[mode as keyof typeof LEGACY_MODE_MAP];
  }
  return mode as SafeCircleMode;
}

export function migrateLegacyMode<T extends { mode?: string }>(obj: T): T {
  if (!obj || typeof obj !== "object") return obj;
  const mapped = migrateLegacyModeValue(obj.mode);
  if (mapped && mapped !== obj.mode) {
    return { ...obj, mode: mapped };
  }
  return obj;
}
